import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import type { ChangeEvent, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { company } from '~/company/Company';
import { Button } from '~/components/isolated/Button';
import { SimpleInput } from '~/components/isolated/SimpleInput';
import { searchStore } from '~/stores/SearchStore';

import styles from './SearchHeader.module.scss';

interface SearchHeaderProps {
  isFocused: boolean;
  hasQuery: boolean;
  setIsFocused: (value: boolean) => void;
  handleKeyUp: (e: KeyboardEvent<HTMLInputElement>) => void;
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleReset: () => void;
  handleCancel: () => void;
}

export const SearchHeader = observer(
  ({
    hasQuery,
    setIsFocused,
    handleKeyUp,
    handleInputChange,
    handleReset,
    handleCancel,
  }: SearchHeaderProps) => {
    const { t } = useTranslation();

    return (
      <div className={styles.mobileHeaderSearchV3}>
        <div className={styles.searchInputWrapper}>
          <SimpleInput
            id="header-search-v3"
            type="text"
            value={searchStore.queryString}
            autoFocus
            placeholder={t('header:searchProducts')}
            onKeyUp={handleKeyUp}
            onChange={handleInputChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            clearable
            onClear={handleReset}
            className={company.match({
              mcosmetic: 'max-h-10',
            })}
          />
        </div>

        <div
          className={classes([styles.buttonWrapper, hasQuery && styles.hidden])}
        >
          <Button
            variant="outlined"
            size="M"
            onClick={handleCancel}
            className={styles.cancelButton}
          >
            {t('cancel')}
          </Button>
        </div>
      </div>
    );
  },
);
